import React from 'react';
import { UserInfo } from '@/services/user/index.d';
import { Method } from '@/services/user/index.d';
import WechatIcon from '@/assets/image/vip/wechat-icon.png';
import QQIcon from '@/assets/image/vip/qq-icon.png';
import WeiboIcon from '@/assets/image/vip/weibo-icon.png';

import styles from './index.module.css';

interface IProps {
  userInfo?: UserInfo;
}

const LoginMethods: React.FC<IProps> = ({ userInfo }) => {
  // 登录方式排序。登录方式：最多展示2个
  // 优先级为：手机号＞微信＞QQ＞微博
  const sortAry = [Method.WEIBO, Method.QQ, Method.WECHART, Method.PHONE];
  let list = (userInfo?.login_methods || []).map((item) => {
    const temp = Object.assign({}, item) as any;
    const index = sortAry.findIndex((key) => key === temp.icon);
    temp.sortIndex = index;
    return temp;
  });

  list = list.sort((a, b) => b.sortIndex - a.sortIndex).slice(0, 2);

  return (
    <>
      {list.map((item, index) => {
        if (item.icon === Method.PHONE) {
          return (
            <span key={index}>
              {item.content}
              {index < list.length - 1 ? '；' : ''}
            </span>
          );
        } else if (item.icon === Method.WECHART) {
          return (
            <span key={index}>
              <img className={styles.methodIcon} src={WechatIcon} alt="" />
              {item.content}
              {index < list.length - 1 ? '；' : ''}
            </span>
          );
        } else if (item.icon === Method.QQ) {
          return (
            <span key={index}>
              <img className={styles.methodIcon} src={QQIcon} alt="" />
              {item.content}
              {index < list.length - 1 ? '；' : ''}
            </span>
          );
        } else if (item.icon === Method.WEIBO) {
          return (
            <span key={index}>
              <img className={styles.methodIcon} src={WeiboIcon} alt="" />
              {item.content}
              {index < list.length - 1 ? '；' : ''}
            </span>
          );
        } else {
          return (
            <span key={index}>
              {item.method}: {item.content}
              {index < list.length - 1 ? '；' : ''}
            </span>
          );
        }
      })}
    </>
  );
};

export default React.memo(LoginMethods);
